// import axios from "axios";
// import JoditEditor from "jodit-react";
// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axiosInstance, {
//   getData,
//   postData,
// } from "../../services/FetchNodeServices.js";
// import { Autocomplete, TextField } from "@mui/material";
// import "./product.css";
// import { fileLimit } from "../../services/fileLimit.js";
// const AddProduct = () => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [categoryList, setCategoryList] = useState([]);
//   const [subcategoryList, setSubcategoryList] = useState([]);

//   const [mainCategoriesListe, setMainCategoriesList] = useState([]);
//   const [formData, setFormData] = useState({
//     title: "",
//     images: [],
//     category: "",
//     subCategory: "",
//     price: 0,
//     discount: 0,
//     // stock: 0,
//     finalPrice: 0,
//     description: "",
//     newArrival: "",
//     featuredBooks: "",
//     bestSellingBooks: "",
//     author: "",
//     pages: 0,
//     ISBN: "",
//     publisher: "",
//     publicationDate: "",
//     // language: "",
//   });

//   const navigate = useNavigate();


//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         const response = await axiosInstance.get(
//           "/api/v1/mainCategory/get-all-mainCategories"
//         );
//         if (response) {
//           setMainCategoriesList(response.data?.reverse());
//         }
//       } catch (error) {
//         toast.error("Error fetching categories");
//         console.error("Error fetching categories:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchCategories();
//   }, []);

//   const fetchCategory = async () => {
//     try {
//       const response = await axiosInstance.get(
//         "/api/v1/category/get-all-categories"
//       );
//       if (response?.status === 200) {
//         console.log("response", response.data);

//         setCategoryList(response.data);
//       }
//     } catch (error) {
//       toast.error(
//         error.response
//           ? error.response.data.message
//           : "Error fetching Category data"
//       );
//     }
//   };

//   useEffect(() => {
//     fetchCategory();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleCategoryChange = async (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     try {
//       const res = await axiosInstance.get(
//         `/api/v1/subcategory/get-subcategories-by-category/${value}`
//       );
//       console.log("res", res.data.data);

//       setSubcategoryList(res?.data);
//     } catch (error) {
//       console.log("fetching subcategory error", error);
//       toast.error("Error fetching subcategory data");
//     }
//   };

//   const handleMainCategoryChange = async (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value, category: "", subCategory: "" }));

//     try {
//       const res = await axiosInstance.get(
//         `/api/v1/category/category-by-main-category/${value}`
//       );
//       // console.log("res==>", res.data);
//       setCategoryList(res?.data);
//     } catch (error) {
//       console.log("fetching subcategory error", error);
//       toast.error("Error fetching subcategory data");
//     }
//   };

//   const handleJoditChange = (newValue) => {
//     setFormData((prev) => ({ ...prev, description: newValue }));
//   };
//   console.log('formData===>', formData)
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
//     if (!formData.title) {
//       toast.error("Title is required");
//       return;
//     }
//     if (!formData.images) {
//       toast.error("Images is required");
//       return;
//     }
//     if (!formData.category) {
//       toast.error("Category is required");
//       return;
//     }
//     if (!formData.subCategory) {
//       toast.error("Sub Category is required");
//       return;
//     }
//     if (!formData.price) {
//       toast.error("Price is required");
//       return;
//     }
//     if (!formData.description) {
//       toast.error("Description is required");
//       return;
//     }
//     if (!formData.author) {
//       toast.error("Author is required");
//       return;
//     }
//     if (!formData.pages) {
//       toast.error("Pages is required");
//       return;
//     }
//     if (!formData.ISBN) {
//       toast.error("ISBN is required");
//       return;
//     }
//     if (!formData.publisher) {
//       toast.error("Publisher is required");
//       return;
//     }
//     if (!formData.publicationDate) {
//       toast.error("Publication Date is required");
//       return;
//     }
//     if (!formData.mainCategory) {
//       toast.error("Main Category is required");
//       return;
//     }
//     console.log('formData===>', formData)
//     if (!fileLimit(formData?.coverImage)) return;
//     if (formData.images && Array.isArray(formData.images)) {
//       for (const image of formData.images) {
//         if (!fileLimit(image)) {
//           setIsLoading(false);
//           return;
//         }
//       }
//     }

//     const payload = new FormData();
//     Object.entries(formData).forEach(([key, value]) => {
//       if (Array.isArray(value)) {
//         value.forEach((item) => {
//           payload.append(key, item);
//         });
//       } else {
//         payload.append(key, value);
//       }
//     });
//     try {
//       const response = await axiosInstance.post(
//         "/api/v1/product/create-product",
//         payload,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );
//       if (response.status === 201) {
//         toast.success("product created success");
//         navigate("/all-products");
//         setIsLoading(false);
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error(
//         error?.response?.data?.message ||
//         "Failed to add product. Please try again."
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleFileChange = (e) => {
//     const { name, files } = e.target;
//     if (name === "images") {
//       setFormData((prev) => ({
//         ...prev,
//         images: [...Array.from(files)],
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: files[0] }));
//     }
//   };

//   useEffect(() => {
//     let total = parseFloat(
//       formData.price * (1 - formData.discount / 100)
//     ).toFixed(2);
//     setFormData((prev) => ({ ...prev, finalPrice: total }));
//   }, [formData.price, formData.discount]);

//   console.log("formData==>", formData)
//   return (
//     <>
//       <ToastContainer />

//       <div className="bread">
//         <div className="head">
//           <h4>Add Product</h4>
//         </div>
//         <div className="links">
//           <Link to="/all-products" className="add-new">
//             Back <i className="fa-regular fa-circle-left"></i>
//           </Link>
//         </div>
//       </div>

//       <div className="d-form">
//         <form className="row g-3 mt-2" onSubmit={handleSubmit}>
//           {/* <div className="col-md-3">
//             <label className="form-label">Product Image*</label>
//             <input type="file" className="form-control" multiple onChange={handleFileChange} required />
//           </div> */}

//           <div className="col-md-3">
//             <label className="form-label">Product Name*</label>
//             <input type="text" name="title" className="form-control" value={formData.title} onChange={handleChange} required />
//           </div>

//           <div className="col-md-3">
//             <label className="form-label">author*</label>
//             <input type="text" name="author" className="form-control" value={formData.author} onChange={handleChange} required />
//           </div>

//           <div className="col-md-3">
//             <label className="form-label">pages*</label>
//             <input type="number" name="pages" className="form-control" value={formData.pages} onChange={handleChange} required />
//           </div>

//           <div className="col-md-3">
//             <label className="form-label">ISBN*</label>
//             <input type="text" name="ISBN" className="form-control" value={formData.ISBN} onChange={handleChange} required />
//           </div>
//           {/* <div className="row mt-4">
//             <div className="col-md-6">
//               <label className="form-label">Select Category</label>
//               <select
//                 name="category"
//                 required
//                 onChange={handleCategoryChange}
//                 value={formData.category}
//                 className="form-select"
//               >
//                 <option value="">Select Category</option>
//                 {categoryList.map((category) => (
//                   <option key={category._id} value={category._id}>
//                     {category.SubCategoryName}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="col-md-6">
//               <label className="form-label">Select Sub Category</label>
//               <select
//                 name="subCategory"
//                 required
//                 onChange={handleChange}
//                 value={formData.subCategory}
//                 className="form-select"
//               >
//                 <option value="">Select Sub Category</option>
//                 {subcategoryList?.map((subCategory) => (
//                   <option key={subCategory._id} value={subCategory._id}>
//                     {subCategory.subCategoryName}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div> */}
//           <div className="row mt-4">

//             <div className="col-md-4">
//               <label className="form-label">Select Main Category</label>
//               <select
//                 name="mainCategory"
//                 // required
//                 onChange={handleMainCategoryChange}
//                 value={formData?.mainCategory}
//                 className="form-select"
//               >
//                 <option value="">Select Main Category</option>
//                 {mainCategoriesListe.map((category) => (
//                   <option key={category._id} value={category._id}>
//                     {category?.Parent_name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="col-md-4">
//               <label className="form-label">Select Category</label>
//               <select
//                 name="category"
//                 // required
//                 onChange={handleCategoryChange}
//                 value={formData?.category}
//                 className="form-select"
//               >
//                 <option value="">Select Category</option>
//                 {categoryList.map((category) => (
//                   <option key={category._id} value={category._id}>
//                     {category.SubCategoryName}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="col-md-4">
//               <label className="form-label">Select Sub Category</label>
//               <select
//                 name="subCategory"
//                 // required
//                 onChange={handleChange}
//                 value={formData?.subCategory}
//                 className="form-select"
//               >
//                 <option value="">Select Sub Category</option>
//                 {subcategoryList?.map((subCategory) => (
//                   <option key={subCategory._id} value={subCategory._id}>
//                     {subCategory.subCategoryName}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           <div className="col-md-3">
//             <label className="form-label">publisher*</label>
//             <input
//               type="text"
//               name="publisher"
//               className="form-control"
//               value={formData.publisher}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div className="col-md-3">
//             <label className="form-label">Publication Date*</label>
//             <input type="text" name="publicationDate" className="form-control" value={formData.publicationDate} onChange={handleChange} required />
//           </div>
//           {/* <div className="col-md-3">
//             <label className="form-label">Language*</label>
//             <input
//               type="text"
//               name="language"
//               className="form-control"
//               list="doorOptions"
//               value={formData.language}
//               onChange={handleChange}
//               required
//             />
//             <datalist id="doorOptions">
//               <option value="Single Door" />
//               <option value="Sliding brand" />
//               <option value="Mirror Door" />
//               <option value="Sliding Mirror Door" />
//               <option value="Double Door" />
//               <option value="Triple Door" />
//               <option value="Four Door" />
//             </datalist>
//           </div> */}

//           {/* <div className="col-md-3">
//             <label className="form-label">Select Type</label>
//             <Autocomplete
//               multiple
//               options={typeOptions}

//               value={typeOptions.filter((opt) => formData.type.includes(opt.name))}
//               onChange={(e, newValue) => setFormData((prev) => ({ ...prev, type: newValue.map((opt) => opt.name), }))
//               }
//               getOptionLabel={(option) => option.name}
//               // value={typeOptions.find((opt) => opt.name === formData.type) || null}
//               // onChange={(e, value) => setFormData({ ...formData, type: value?.name || "" })}
//               renderInput={(params) => <TextField {...params} label="Select Type" />}
//             />
//           </div> */}

//           <div className="col-md-3">
//             <label className="form-label">Images</label>
//             <input
//               type="file"
//               multiple
//               name="images"
//               className="form-control"
//               onChange={handleFileChange}
//               maxLength={4}
//             />
//           </div>

//           <div className="col-md-12">
//             <label className="form-label">Product Description*</label>
//             <JoditEditor
//               value={formData.description}
//               onChange={handleJoditChange}
//             />
//           </div>

//           <div className="row">
//             <div className="col-md-2">
//               <label className="form-label">Price(USD)*</label>
//               <input
//                 type="number"
//                 name="price"
//                 className="form-control"
//                 value={formData.price}
//                 onChange={handleChange}
//                 required
//               />
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Discount %*</label>
//               <input
//                 type="number"
//                 name="discount"
//                 className="form-control"
//                 value={formData.discount}
//                 onChange={handleChange}
//                 min={0}
//                 max={100}
//                 required
//               />
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Final Price(USD)*</label>
//               <input
//                 type="number"
//                 name="finalPrice"
//                 className="form-control"
//                 value={formData.finalPrice}
//                 readOnly
//               />
//             </div>

//             {/* <div className="col-md-2">
//               <label className="form-label">Stock</label>
//               <input
//                 type="text"
//                 name="stock"
//                 className="form-control"
//                 value={formData.stock}
//                 onChange={handleChange}
//               />
//             </div> */}
//           </div>
//           {/* <div className="row" style={{ marginTop: "20px" }}>
//             <div className="col-md-3">
//               <label className="form-label">Specifications*</label>
//               <input
//                 type="text"
//                 name="Specifications"
//                 className="form-control"
//                 value={formData.Specifications}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div className="col-md-3">
//               <label className="form-label">BrandCollectionOverview*</label>
//               <input
//                 type="text"
//                 name="BrandCollectionOverview"
//                 className="form-control"
//                 value={formData.BrandCollectionOverview}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div className="col-md-3">
//               <label className="form-label">CareMaintenance*</label>
//               <input
//                 type="text"
//                 name="CareMaintenance"
//                 className="form-control"
//                 value={formData.CareMaintenance}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div className="col-md-3">
//               <label className="form-label">seller*</label>
//               <input
//                 type="text"
//                 name="seller"
//                 className="form-control"
//                 value={formData.seller}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div className="col-md-3">
//               <label className="form-label">Warranty*</label>
//               <input
//                 type="text"
//                 name="Warranty"
//                 className="form-control"
//                 value={formData.Warranty}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//           </div>
//           <div className="col-12" style={{ marginTop: "20px" }}>
//             <div className="form-check">
//               <input
//                 className="form-check-input"
//                 type="checkbox"
//                 id="status"
//                 checked={formData.isFeatured}
//                 onChange={(e) =>
//                   setFormData({ ...formData, isFeatured: e.target.checked })
//                 }
//               />
//               <label className="form-check-label" htmlFor="status">
//                 Featured Product
//               </label>
//             </div>
//           </div> */}
//           <div className="row mt-3">
//             <div className="col-md-4">
//               <div className="form-check">
//                 <input
//                   className="form-check-input"
//                   type="checkbox"
//                   id="newArrival"
//                   checked={formData.newArrival === "true"}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       newArrival: e.target.checked.toString(),
//                     })
//                   }
//                 />
//                 <label className="form-check-label" htmlFor="newArrival">
//                   New Arrival
//                 </label>
//               </div>
//             </div>
//             <div className="col-md-4">
//               <div className="form-check">
//                 <input
//                   className="form-check-input"
//                   type="checkbox"
//                   id="featuredBooks"
//                   checked={formData.featuredBooks === "true"}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       featuredBooks: e.target.checked.toString(),
//                     })
//                   }
//                 />
//                 <label className="form-check-label" htmlFor="featuredBooks">
//                   Featured Books
//                 </label>
//               </div>
//             </div>
//             <div className="col-md-4">
//               <div className="form-check">
//                 <input
//                   className="form-check-input"
//                   type="checkbox"
//                   id="bestSellingBooks"
//                   checked={formData.bestSellingBooks === "true"}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       bestSellingBooks: e.target.checked.toString(),
//                     })
//                   }
//                 />
//                 <label className="form-check-label" htmlFor="bestSellingBooks">
//                   Best Selling Books
//                 </label>
//               </div>
//             </div>
//           </div>

//           <div className="col-md-12 mt-4 text-center">
//             <button type="submit" className="btn " disabled={isLoading}>
//               {isLoading ? "Submitting..." : "Submit"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </>
//   );
// };

// export default AddProduct;


import axios from "axios";
import JoditEditor from "jodit-react";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../services/FetchNodeServices.js";
import "./product.css";
import { fileLimit } from "../../services/fileLimit.js";

const AddProduct = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [subcategoryList, setSubcategoryList] = useState([]);
  const [mainCategoriesListe, setMainCategoriesList] = useState([]);

  const [formData, setFormData] = useState({
    title: "",
    images: [],
    category: "",
    subCategory: "",
    mainCategory: "",
    price: 0,
    discount: 0,
    finalPrice: 0,
    description: "",
    newArrival: "",
    featuredBooks: "",
    bestSellingBooks: "",
    author: "",
    pages: 0,
    ISBN: "",
    publisher: "",
    publicationDate: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axiosInstance.get(
          "/api/v1/mainCategory/get-all-mainCategories"
        );
        if (response) {
          setMainCategoriesList(response.data?.reverse());
        }
      } catch (error) {
        toast.error("Error fetching categories");
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await axiosInstance.get(
          "/api/v1/category/get-all-categories"
        );
        if (response?.status === 200) {
          setCategoryList(response.data);
        }
      } catch (error) {
        toast.error(
          error.response ? error.response.data.message : "Error fetching Category data"
        );
      }
    };
    fetchCategory();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCategoryChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    try {
      const res = await axiosInstance.get(
        `/api/v1/subcategory/get-subcategories-by-category/${value}`
      );
      setSubcategoryList(res?.data);
    } catch (error) {
      toast.error("Error fetching subcategory data");
    }
  };

  const handleMainCategoryChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value, category: "", subCategory: "" }));
    try {
      const res = await axiosInstance.get(
        `/api/v1/category/category-by-main-category/${value}`
      );
      setCategoryList(res?.data);
    } catch (error) {
      toast.error("Error fetching category data");
    }
  };

  const handleJoditChange = (newValue) => {
    setFormData((prev) => ({ ...prev, description: newValue }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (name === "images") {
      setFormData((prev) => ({ ...prev, images: [...Array.from(files)] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    }
  };

  useEffect(() => {
    const total = parseFloat(
      formData.price * (1 - formData.discount / 100)
    ).toFixed(2);
    setFormData((prev) => ({ ...prev, finalPrice: total }));
  }, [formData.price, formData.discount]);

  // ✅ FIX: helper to show toast + stop loading + return false
  const validationError = (msg) => {
    toast.error(msg);
    setIsLoading(false);
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // ✅ FIX: all validations return early properly
    if (!formData.title.trim()) return validationError("Title is required");
    // ✅ FIX: array length check instead of ![]
    if (!formData.author.trim()) return validationError("Author is required");
    if (!formData.pages || formData.pages <= 0) return validationError("Pages is required");
    if (!formData.ISBN.trim()) return validationError("ISBN is required");
    if (!formData.mainCategory) return validationError("Main Category is required");
    // if (!formData.category) return validationError("Category is required");
    // if (!formData.subCategory) return validationError("Sub Category is required");
    if (!formData.publisher.trim()) return validationError("Publisher is required");
    if (!formData.publicationDate.trim()) return validationError("Publication Date is required");
    if (!formData.images || formData.images.length === 0) return validationError("At least one image is required");
    if (!formData.description.trim()) return validationError("Description is required");
    if (!formData.price || formData.price <= 0) return validationError("Price is required");

    // ✅ FIX: removed coverImage check — not in formData
    if (formData.images && Array.isArray(formData.images)) {
      for (const image of formData.images) {
        if (!fileLimit(image)) {
          setIsLoading(false);
          return;
        }
      }
    }

    const payload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item) => payload.append(key, item));
      } else {
        payload.append(key, value);
      }
    });

    try {
      const response = await axiosInstance.post(
        "/api/v1/product/create-product",
        payload,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (response.status === 201) {
        toast.success("Product created successfully");
        navigate("/all-products");
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error?.response?.data?.message || "Failed to add product. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="bread">
        <div className="head">
          <h4>Add Product</h4>
        </div>
        <div className="links">
          <Link to="/all-products" className="add-new">
            Back <i className="fa-regular fa-circle-left"></i>
          </Link>
        </div>
      </div>

      <div className="d-form">
        <form className="row g-3 mt-2" onSubmit={handleSubmit}>

          <div className="col-md-3">
            <label className="form-label">Product Name*</label>
            <input type="text" name="title" className="form-control" value={formData.title} onChange={handleChange} />
          </div>

          <div className="col-md-3">
            <label className="form-label">Author*</label>
            <input type="text" name="author" className="form-control" value={formData.author} onChange={handleChange} />
          </div>

          <div className="col-md-3">
            <label className="form-label">Pages*</label>
            <input type="number" name="pages" className="form-control" value={formData.pages} onChange={handleChange} />
          </div>

          <div className="col-md-3">
            <label className="form-label">ISBN*</label>
            <input type="text" name="ISBN" className="form-control" value={formData.ISBN} onChange={handleChange} />
          </div>

          <div className="row mt-4">
            <div className="col-md-4">
              <label className="form-label">Select Main Category</label>
              <select name="mainCategory" onChange={handleMainCategoryChange} value={formData.mainCategory} className="form-select">
                <option value="">Select Main Category</option>
                {mainCategoriesListe.map((category) => (
                  <option key={category._id} value={category._id}>{category?.Parent_name}</option>
                ))}
              </select>
            </div>

            <div className="col-md-4">
              <label className="form-label">Select Category</label>
              <select name="category" onChange={handleCategoryChange} value={formData.category} className="form-select">
                <option value="">Select Category</option>
                {categoryList.map((category) => (
                  <option key={category._id} value={category._id}>{category.SubCategoryName}</option>
                ))}
              </select>
            </div>

            <div className="col-md-4">
              <label className="form-label">Select Sub Category</label>
              <select name="subCategory" onChange={handleChange} value={formData.subCategory} className="form-select">
                <option value="">Select Sub Category</option>
                {subcategoryList?.map((subCategory) => (
                  <option key={subCategory._id} value={subCategory._id}>{subCategory.subCategoryName}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-md-3">
            <label className="form-label">Publisher*</label>
            <input type="text" name="publisher" className="form-control" value={formData.publisher} onChange={handleChange} />
          </div>

          <div className="col-md-3">
            <label className="form-label">Publication Date*</label>
            <input type="text" name="publicationDate" className="form-control" value={formData.publicationDate} onChange={handleChange} />
          </div>

          <div className="col-md-3">
            <label className="form-label">Images*</label>
            <input type="file" multiple name="images" className="form-control" onChange={handleFileChange} />
            {/* ✅ Show selected file count */}
            {formData.images.length > 0 && (
              <small className="text-muted">{formData.images.length} file(s) selected</small>
            )}
          </div>

          <div className="col-md-12">
            <label className="form-label">Product Description*</label>
            <JoditEditor value={formData.description} onChange={handleJoditChange} />
          </div>

          <div className="row">
            <div className="col-md-2">
              <label className="form-label">Price (USD)*</label>
              <input type="number" name="price" className="form-control" value={formData.price} onChange={handleChange} />
            </div>

            <div className="col-md-2">
              <label className="form-label">Discount %</label>
              <input type="number" name="discount" className="form-control" value={formData.discount} onChange={handleChange} min={0} max={100} />
            </div>

            <div className="col-md-2">
              <label className="form-label">Final Price (USD)</label>
              <input type="number" name="finalPrice" className="form-control" value={formData.finalPrice} readOnly />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md-4">
              <div className="form-check">
                <input
                  className="form-check-input" type="checkbox" id="newArrival"
                  checked={formData.newArrival === "true"}
                  onChange={(e) => setFormData({ ...formData, newArrival: e.target.checked.toString() })}
                />
                <label className="form-check-label" htmlFor="newArrival">New Arrival</label>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-check">
                <input
                  className="form-check-input" type="checkbox" id="featuredBooks"
                  checked={formData.featuredBooks === "true"}
                  onChange={(e) => setFormData({ ...formData, featuredBooks: e.target.checked.toString() })}
                />
                <label className="form-check-label" htmlFor="featuredBooks">Featured Books</label>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-check">
                <input
                  className="form-check-input" type="checkbox" id="bestSellingBooks"
                  checked={formData.bestSellingBooks === "true"}
                  onChange={(e) => setFormData({ ...formData, bestSellingBooks: e.target.checked.toString() })}
                />
                <label className="form-check-label" htmlFor="bestSellingBooks">Best Selling Books</label>
              </div>
            </div>
          </div>

          <div className="col-md-12 mt-4 text-center">
            <button type="submit" className="btn" disabled={isLoading}>
              {isLoading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddProduct;